import React from 'react'
import styled from '@emotion/styled'
import { string } from 'prop-types'

// Import Components
import { RfqWidget } from '@jelly/components'

// Styled Components via Emotion
const PricingContainer = styled.div`
	width: 100%;
`

Pricing.propTypes = {
	intro: string.isRequired,
	widgetId: string.isRequired,
}

/**
 * This is the Pricing Section for category pages
 * Will display the intro and rfq widget
 *
 * TODO: check data widgetId
 */
export function Pricing({ intro, widgetId }) {
	return (
		<PricingContainer>
			<div dangerouslySetInnerHTML={{ __html: intro }}></div>
			<RfqWidget widgetCategoryId={widgetId} />
		</PricingContainer>
	)
}
